export function polishPluralization(choice, choicesLength) {
  if (choice === 0 || choice === -1) {
    return 0
  }

  if (choice === 1) {
    return 1
  }

  if (choice > 1 && choice < 5) {
    return 2
  }

  return choicesLength < 4 ? 2 : 3
}
